// src/modules/COGS/COGSDashboard.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../components/BackButton';
import DashboardTab from './DashboardTab';
import COGSTab from './COGSTab';
import BreakevenTab from './BreakevenTab';
import SpecialsTab from './SpecialsTab';

const COGSDashboard = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState('dashboard');
  const [items, setItems] = useState([]);
  
  useEffect(() => {
    // Fetch COGS data here
    // This is just mock data, replace with actual API call when i set up the api and link to DB
    setItems([
      { 
        id: 1, 
        name: 'DROVER BEEF BURGER', 
        cost: 7.94, 
        price: 21.74, 
        margin: 63.48,
        ingredients: [
          { name: 'Miratorg Brisket', quantity: 0.120, unit: 'Kg', unitCost: 33.00 },
          { name: 'Miratorg Chuck', quantity: 0.030, unit: 'Kg', unitCost: 33.00 },
          { name: 'Burger Bun', quantity: 1, unit: 'Pc', unitCost: 0.25 },
          // ... other ingredients
        ]
      },
      // ... other items
    ]);
  }, []);

  const renderTabs = () => (
    <div className="flex justify-center mb-6">
      <div className="inline-flex rounded-md shadow-sm" role="group">
        {['Dashboard', 'COGS', 'Breakeven Point', 'Specials'].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveCategory(tab.toLowerCase().replace(' ', '-'))}
            className={`px-4 py-2 text-sm font-medium ${
              activeCategory === tab.toLowerCase().replace(' ', '-')
                ? 'text-blue-700 bg-blue-100 hover:bg-blue-200'
                : 'text-gray-900 bg-white hover:bg-gray-100'
            } border border-gray-200 ${
              tab === 'Dashboard' ? 'rounded-l-lg' : tab === 'Specials' ? 'rounded-r-lg' : ''
            }`}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="p-6 bg-gray-100">
      <BackButton />
      <h1 className="text-3xl font-bold mb-6">COGS Analytics Dashboard</h1>
      
      {renderTabs()}

      {activeCategory === 'dashboard' && <DashboardTab items={items} />}
      {activeCategory === 'cogs' && <COGSTab items={items} setItems={setItems} />}
      {activeCategory === 'breakeven-point' && <BreakevenTab items={items} />}
      {activeCategory === 'specials' && <SpecialsTab items={items} />}
    </div>
  );
};

export default COGSDashboard; 